export default "__VITE_ASSET__WYpbJDI1__"